<template>
  <div class="scene-round" :selected="checked">
    <div class="header">
      <el-checkbox v-model="checked" :label="device.name" @change="$emit('change',checked)"></el-checkbox>
      <div class="icon">
        <slot name="icon"></slot>
      </div>
    </div>
    <div class="content" v-show="expand">
      <slot></slot>
    </div>
    <div class="footer" @click="expand=!expand">
      <img :src="expand?require('../../assets/images/scene/custom/zk.png'):require('../../assets/images/scene/custom/sq.png')" style="width: 14px"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SceneRound',
  props: {
    device: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      expand: false,
      checked: false
    }
  },
  watch: {
    'device.checked' () {
      this.checked = this.device.checked
    }
  }
}
</script>

<style scoped lang="less">
.scene-round[selected] {
  border: 1px solid rgba(58, 212, 116, 1);
}

.scene-round {
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 3px 17px 2px rgba(219, 219, 219, 0.4);
  border-radius: 8px;
  display: flex;
  width: calc(50% - 10px);
  min-width: 280px;
  flex-direction: column;
  margin-bottom: 20px;
  margin-top: 0px;
  & .header {
    height: 84px;
    padding: 20px 20px 0px 20px;
    display: flex;
    justify-content: space-between;
    & .icon {
      margin: -10px;
    }
  }
  & .content {
    padding-bottom: 5px;
  }
  & .footer {
    height: 35px;
    border-top: 1px solid rgba(223, 225, 229, .4);
    line-height: 35px;
    text-align: center;
    cursor: pointer;
  }
}
</style>
<style lang="less">
.scene-round {
  & .el-checkbox__label {
    font-size: 18px;
    font-weight: 600;
    color: rgba(38, 38, 38, 1)
  }
}
</style>
